<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :title="form.id ? '编辑员工特殊工时' : '新增员工特殊工时'"
    width="650px"
    top="8vh"
    @closed="resetForm"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="员工" prop="empId">
        <el-input v-model="empName" placeholder="请选择员工" readonly>
          <el-button slot="append" icon="el-icon-search" @click="$refs.employeeSelect.open()"/>
        </el-input>
      </el-form-item>
      <el-form-item label="统计日期" prop="statDate">
        <el-date-picker v-model="form.statDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择统计日期" style="width:100%"/>
      </el-form-item>
      <el-form-item label="工时类型" prop="empAbnormalHourType">
        <el-select v-model="form.empAbnormalHourType" placeholder="请选择工时类型" style="width:100%">
          <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"/>
        </el-select>
      </el-form-item>
      <el-form-item label="工时(H)" prop="abnormalDuration">
        <el-input-number v-model="form.abnormalDuration" :min="0" :precision="2" controls-position="right" style="width:100%"/>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入备注"/>
      </el-form-item>
    </el-form>

    <common-select
      ref="employeeSelect"
      title="选择员工"
      url="employees"
      :columns="employeeColumns"
      :search-items="employeeSearchItems"
      :filter="employeeFilter"
      @select="selectEmployee"
    />

    <div slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" :loading="loading" @click="submitHandle">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import CommonSelect from "../CommonSelect";

  export default {
    name: "EmpAbnormalHourEdit",
    components: { CommonSelect },
    data() {
      return {
        dialogVisible: false,
        loading: false,
        empName: "",
        typeOptions: [
          { label: "年假", value: 1 },
          { label: "婚假", value: 2 },
          { label: "丧假", value: 3 },
          { label: "产假/陪产假", value: 4 },
          { label: "事假", value: 5 },
          { label: "调休", value: 6 },
          { label: "顶岗", value: 7 },
          { label: "员工个人加班", value: 8 },
          { label: "班组集体加班", value: 9 },
          { label: "工伤医疗期", value: 10 },
          { label: "外出培训", value: 11 },
          { label: "外出公干/跨厂支援", value: 12 },
          { label: "居家办公", value: 13 },
          { label: "停工待料带薪", value: 14 },
          { label: "隔离观察带薪", value: 15 },
          { label: "其他特殊工时", value: 16 },
        ],
        employeeFilter: { employeeNO: "", employeeName: "" },
        employeeSearchItems: [
          { key: "employeeNO", label: "员工编号", placeholder: "请输入员工编号" },
          { key: "employeeName", label: "员工姓名", placeholder: "请输入员工姓名" },
        ],
        employeeColumns: [
          { title: "员工编号", key: "employeeNO", width: 120, align: "center" },
          { title: "员工姓名", key: "employeeName", width: 120 },
          { title: "操作", slot: "action", width: 80, align: "center" },
        ],
        form: {},
        rules: {
          empId: [{ required: true, message: "请选择员工", trigger: "change" }],
          statDate: [{ required: true, message: "请选择统计日期", trigger: "change" }],
          empAbnormalHourType: [{ required: true, message: "请选择工时类型", trigger: "change" }],
        },
      };
    },
    methods: {
      resetForm() {
        this.form = {};
        this.empName = "";
        this.$refs.form && this.$refs.form.resetFields();
      },
      open(row) {
        this.dialogVisible = true;
        if (row && row.id) {
          this.form = { ...row };
          this.empName = row.empName || "";
        } else {
          this.form = {
            statDate: "",
            empId: null,
            empNo: "",
            empName: "",
            empAbnormalHourType: null,
            empAbnormalHourName: "",
            abnormalDuration: null,
            remark: "",
          };
          this.empName = "";
        }
      },
      selectEmployee(row) {
        this.form.empId = row.employeeID;
        this.form.empNo = row.employeeNO;
        this.form.empName = row.employeeName;
        this.empName = row.employeeName;
      },
      submitHandle() {
        this.$refs.form.validate((valid) => {
          if (!valid) return;
          this.loading = true;
          this.$http.save("basic", "empAbnormalHours", this.form)
            .then((resp) => {
              if (resp.success) {
                this.$message.success(this.form.id ? "编辑成功" : "新增成功");
                this.dialogVisible = false;
                this.$emit("save-success");
              }
            })
            .finally(() => {
              this.loading = false;
            });
        });
      },
    },
  };
</script>
